/**
 * This is the forgotten controller.
 * @memberOf Forgotten Module
 * @namespace Forgotten Controller
 */

/**
 * @name forgottenController
 * @desc Create the controller.
 * @param $scope
 * @param $http
 * @param $translate
 * @param coreService
 * @param forgottenService
 * @memberOf Forgotten Module.Forgotten Controller
 * @ngInject
 */
function forgottenController($scope, $http, $translate, coreService, forgottenService, $log, useEmailLogin, $window) {

    // Assign this controller as the view-model.
    // It will be accessible as 'forgottenController' within the HTML template.
    var vm = this;

    // Register the view model's properties.
    vm.submitForm = submitForm;
    vm.submitted = false;
    vm.receivedResponse = false;
    vm.success = false;
    vm.messages = [];
    vm.showHelpPanel = showHelpPanel;
    vm.helpPanels = {};
    vm.user = coreService.user;
    vm.unsupportedBrowser = false;
    vm.useEmailLogin = useEmailLogin;
    vm.displayErrorsOnUserName = displayErrorsOnUserName;
    vm.displayErrorsOnEmail= displayErrorsOnEmail;

    vm.isPasswordErrorValue = '';
    vm.isEmailErrorValue = '';
    vm.isUserNameError = false;
    vm.isEmailError = false;
    vm.formDirty = false;
    vm.useLegacyForgotPassword = false;

    var ie9 = window.document.documentMode <= 9; // IE9 or below
    // Activate the controller.
    activate();

    // Activates the controller.
    function activate() {   

        // Read Identity Server's data model
        var model = coreService.getIdentityModel();

        // Change display language
        if (model.custom && model.custom.ui_locales) {
            $translate.use(model.custom.ui_locales);
        }

        // Construct reset password url
        if (model.custom && model.custom.api_base) {
            $scope.resetPasswordUrl = model.custom.api_base + '/account/resetpassword';
        }

        if (model.custom && model.custom.use_legacy_forgot_password == '1') {
          vm.useLegacyForgotPassword = true;
        }

        $scope.model = model;

        $translate(['forgotten.form.header', 'forgotten.form.description', 'forgotten.form.username',
        'forgotten.form.username_required', 'forgotten.form.username_minlength', 'forgotten.form.username_maxlength',
         'forgotten.form.email_required', 'forgotten.form.email_minlength', 'forgotten.form.email_maxlength', 'forgotten.form.email_invalid']) 
           .then(function(data) {
            vm.data = data; 
            setAriaLabelOnLoad(true);
            setFocus("username");   
         });       
    }

    $scope.$watch('model.custom.ui_locales', function() { 
      if(typeof($scope.model) != 'undefined' && $scope.model != null && typeof($scope.model.custom) != 'undefined' && $scope.model.custom != null)
      {
      $translate.preferredLanguage($scope.model.custom.ui_locales);
      $translate(['forgotten.form.header', 'forgotten.form.description', 'forgotten.form.username',
      'forgotten.form.username_required', 'forgotten.form.username_minlength', 'forgotten.form.username_maxlength',
       'forgotten.form.email_required', 'forgotten.form.email_minlength', 'forgotten.form.email_maxlength', 'forgotten.form.email_invalid']) 
      .then(function(data) {
      vm.data = data; 
      });
      }
    });
 

    function setFocus(id)
    {
      var element = $window.document.getElementById(id);
      if(typeof(element) != 'undefined' && element != null)
      {
        $window.setTimeout(function(){ element.focus(); }, 0);
      }      
    }

    function setAriaLabelOnLoad(enable) {
        var element = document.getElementById('username');
        if(typeof(element) != 'undefined' && element != null)
        {
        if (enable)
        {
            var arialDescriptionText = vm.data['forgotten.form.header'] + ". " + vm.data['forgotten.form.description'];          
            element.setAttribute('aria-label', arialDescriptionText);
        }
        else
        {
            element.setAttribute('aria-label', vm.data['forgotten.form.username']);
        }
       }
    }
   
    function clearErrors()
    {
      var formErrors = $window.document.getElementById('formErrors');
      if(typeof(formErrors) != 'undefined' && formErrors != null)
      {
       formErrors.innerHTML = '';
      }
    }

    function displayErrorsOnUserName(e)
    {
      var userName = getUserNameElement().value;

      if(isSubmitClick(e,userName))
      {
       return;
      }
      
      setAriaLabelOnLoad(false);
      vm.isUserNameErrorValue = '';
      if(vm.isUserNameError)
      {
        clearErrors();   
      }      
      vm.formDirty = false;
      vm.isUserNameError = false;
       
       if (userName != '' && $scope.forgottenForm.name.$error.minlength)
       {           
           vm.isUserNameErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.username_minlength'] +'</span><br/>';
           vm.formDirty = true;  
           vm.isUserNameError = true;  
           vm.isPasswordError = false;
            if(vm.useEmailLogin)
            {
            vm.isEmailError = false; 
            }   
       }
       if (userName != '' && $scope.forgottenForm.name.$error.maxlength)
       {           
           vm.isUserNameErrorValue =  vm.isUserNameErrorValue + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.username_maxlength'] +'</span><br/>';
           vm.formDirty = true;   
           vm.isUserNameError = true;
           vm.isPasswordError = false;
           if(vm.useEmailLogin)
           {
            vm.isEmailError = false; 
           } 
       }     

       if(vm.formDirty)
       {
        displayErrors(vm.isUserNameErrorValue);     
        setFocus("username");       
      }     
    }

    function validateEmptyFields() {
        var valUsername = getUserNameElement().value;
        var valEmail= getEmailElement().value;

        if (valUsername == "" && !vm.isEmailError)
        {
          vm.isUserNameErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.username_required'] +'</span><br/>';
          vm.formDirty = true;
          vm.isUserNameError = true; 
          vm.isEmailError = false; 
          displayErrors(vm.isUserNameErrorValue);
          setFocus("username"); 
          return false;
       }       
       else if (valEmail == "" && !vm.isUserNameError)
       {
          vm.isEmailErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.email_required'] +'</span><br/>';
          vm.formDirty = true;
          vm.isEmailError = true;
          vm.isUserNameError = false;
          displayErrors(vm.isEmailErrorValue);
          setFocus("email"); 
          return false;
       }
                
      return true;
    }

    function displayErrors(error)
    {
      var formErrors = $window.document.getElementById('formErrors');
      if(typeof(formErrors) != 'undefined' && formErrors != null)
      {
       formErrors.setAttribute('name', 'formError_' + new Date().getTime());
       formErrors.innerHTML =  error;    
      }
    }

    function getEmailElement()
    {
      return $window.document.getElementById("email");
    }

    function isSubmitClick(e, element)
    {
       // If blur is triggered and the target element is submit button, short circuit this call 
       // to trigger the onclick validation
       if(element.replace(/^\s+|\s+$/g, '') === '' && e !== null && e !== 'undefined' && e.relatedTarget !== null && e.relatedTarget.id !== null && e.relatedTarget.id === 'submitforgotten'){
        return true;
       }
       else
       {
         return false;
       }
    }
    
    function displayErrorsOnEmail(e)
    {
       var email = getEmailElement().value;

       if(isSubmitClick(e,email))
       {
        return;
       }

        vm.messages = '';
        vm.isEmailErrorValue = '';
        if(vm.isEmailError)
        {
          clearErrors();
        }
        vm.isEmailError = false; 
        vm.formDirty = false;        
        
        if (email != '' && $scope.forgottenForm.email.$error.minlength)
       {           
           vm.isEmailErrorValue =  '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.email_minlength'] +'</span><br/>';
           vm.formDirty = true;  
           vm.isEmailError = true;  
           vm.UserNameError = false; 
       }
       if (email != '' && $scope.forgottenForm.email.$error.maxlength)
       {           
           vm.isEmailErrorValue =  vm.isEmailErrorValue + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.email_maxlength'] +'</span><br/>';
           vm.formDirty = true;  
           vm.isEmailError = true;  
           vm.UserNameError = false; 
       } 
       if (email != '' && $scope.forgottenForm.email.$error.email)
       {           
           vm.isEmailErrorValue =  vm.isEmailErrorValue + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['forgotten.form.email_invalid'] +'</span><br/>';
           vm.formDirty = true;  
           vm.isEmailError = true;  
           vm.UserNameError = false; 
       }    

         if(vm.formDirty)
         {
          displayErrors(vm.isEmailErrorValue);
          setFocus("email");      
        }      
    }

    function getUserNameElement()
    {
      return $window.document.getElementById("username");
    }

    // Submit the login forgotten form.
    function submitForm($event) {
      var isValid = validateEmptyFields();

      if (isValid === false) {
          // Do not submit
          $event.preventDefault();
      }
      else  // Only submit if the form is valid.
      {
        var username = vm.user.name;

        //handle user name with email scenario
        if(vm.useEmailLogin)
        {
          username = vm.user.name + '_' + vm.email;
        }
  
        // Update the form.
        vm.messages = [];
        vm.submitted = true;
        $scope.forgottenForm.$dirty = true;
        $scope.forgottenForm.$pristine = false;

        if ($scope.forgottenForm.$valid) {
          let transformRequest = function(obj){
            var str = [];
            for (var p in obj)
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            return str.join("&");
          };
            vm.receivedResponse = false;

            // IE9 and below
            if (ie9) {
              // use XDomainRequest object
              if (typeof XDomainRequest !== "undefined"){
                vm.unsupportedBrowser = false;
                var xdr = new XDomainRequest();
                xdr.open("POST", $scope.resetPasswordUrl + "IE8");
                xdr.onload = function(){
                  $scope.$apply(function(){
                    resetValidation();
                    var response = angular.fromJson(xdr.responseText);
                    vm.success = response.success;
                    vm.receivedResponse = true;
                  });
                };
                xdr.onerror = function(){
                  $scope.$apply(function(){
                    resetValidation();
                    vm.success = false;
                    vm.receivedResponse = true;
                  });
                };
                xdr.send(transformRequest({ username: username, email: vm.email }));
              } else {
                resetValidation();
                vm.unsupportedBrowser = true;
                vm.success = false;
                vm.receivedResponse = true;
              }
            } else {

              // Check whether to use the legacy forgotten password or idam forgotten password
              var resetUrl = '/selfservice/forgotpassword/create';
              var resetParameter = { userid: username, email: vm.email };
              if(vm.useLegacyForgotPassword){
                resetUrl = $scope.resetPasswordUrl;
                resetParameter = { username: username, email: vm.email };
              }

              // Submit the form.
              $http({
                method: 'POST',
                url: resetUrl,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: transformRequest,
                data: resetParameter
              })
                .then(
                  function success(data) {
                    resetValidation();
                    var response = angular.fromJson(data);
                    vm.success = true;
                    vm.receivedResponse = true;
                  },
                  function failure(error) {
                    $log.error(error);
                    vm.success = false;
                    vm.receivedResponse = true;
                  });
            }
        }
      }        
    }

    function resetValidation() {
        $scope.forgottenForm.$setPristine();
    }

    function showHelpPanel(panelId){
        for(var id in $scope.forgottenController.helpPanels){
            if (id != panelId){
                $scope.forgottenController.helpPanels[id] = false;
            }
        }
        $scope.forgottenController.helpPanels[panelId] = !$scope.forgottenController.helpPanels[panelId];
    }
}

export default forgottenController;


// WEBPACK FOOTER //
// ./src/login/forgotten/forgotten.controller.js